<script>
/*jshint esversion: 6 */ 
import {watch, computed, inject} from 'vue';
import './../func.common';
import { FontAwesomeIcon, FontAwesomeLayers} from "@fortawesome/vue-fontawesome";
export default {
    name: 'JobSector',
    components: {
        'font-awesome-icon' : FontAwesomeIcon,
        'font-awesome-layers' : FontAwesomeLayers,
    },
    props: {
        'disabled': {type: Boolean},
        'fullSchema': { type: [Object], default: function() { return {};} }, 
        'hinted': {type: String},
        'id': { type: String, default: ''}, 
        'model': { type: [Object], default: function() { return {};} }, 
        'schema': { type: [Object], default: function() { return {};} }, 
        'schemaId': {type: Number, default: 0}, 
    },
    setup(props, ctx) {
        const validateChild = inject('validateChild');
        const helperName = computed(() => {
            return props.model[props.schema.model];
        });


        watch(() => helperName, (newVal, oldVal) => {
            var toParent = {
                'id': props.schemaId,
                'model': props.schema.model,
                'validator': props.schema.validator,
            };
            if (validateChild) {
                validateChild(toParent);
            }
        }, {deep:true});

        function validateFirstElement() {
            var toParent = {
                'id': props.schemaId,
                'model': props.schema.model,
                'validator': props.schema.validator
            };
            if (validateChild) {
                validateChild(toParent);
            }
        }

        function addJob() {
            if (!props.disabled) {
                props.model[props.schema.model].push([0,0]);
            }
        }

        function deleteJob(index) {
            if (!props.disabled) {
                props.model[props.schema.model].splice(index,1);
            }
        }

        function changeSector(index) {
            props.model[props.schema.model][index][1] = 0;
        }


        return {
            addJob, 
            deleteJob, 
            changeSector, 
            validateFirstElement, 
        }
    }
}
</script>
<template lang="pug">
.vueFormFieldMain
    .jobSectorMain.mt-4(
       :class="[schema.class,disabled === true ? 'fieldDisabled' : ''] "
    )
        label(v-if="schema.label && schema.label.length > 0" v-html="schema.label")
        template(v-for="item, index in model[schema.model]")
            .row.align-items-start(:style="disabled === true ? 'opacity: 0.5; cursor:not-allowed': ''")
                .row.align-items-start
                    .row.justify-content-between
                        .col-12 
                            label {{ index+1 }}. {{schema.mainLabel}}
                            span.redAst(v-if="index === 0") *
                    .cols-12.fieldSelect 
                        .selectField 
                            select.form-select(
                                v-model="item[0]" 
                                @change="changeSector(index)"
                                :style="disabled === true ? 'pointer-events:none' : ''" 
                            )
                                option(disabled value="0") {{schema.firstLabel}} auswählen 
                                template(v-for="item2, index2 in schema.valueAllSectors")
                                    option(:value="item2.id") {{ item2.name }}     
                    .col-12.fieldSelectJobSector
                        .selectField(:class="parseInt(item[0]) === 0 ? 'disabled' : ''")
                            select.form-select(
                                v-model="item[1]"
                                @change="validateFirstElement()"
                                :style="disabled === true ? 'pointer-events:none' : ''" 
                            )
                                option(disabled value="0") {{schema.secondLabel}} auswählen
                                template(v-for="item2, index2 in schema.valueAllJobs")
                                    template(v-if="parseInt(item2.sector) === parseInt(item[0])")
                                        | {{ item2 }}
                                        option(:value="item2.id") {{ item2.name }}    
                    .row.align-items-end.justify-content-end(v-if="!disabled")
                        .col-1.plusButton(
                            v-if="(index+1 === model[schema.model].length) && (parseInt(item[0]) > 0 && parseInt(item[1]) > 0)"
                                @click="addJob(index)"
                            )
                            .row.align-items-end.justify-content-end
                                .col-2
                                    font-awesome-layers.fa-lg.setPlus
                                        font-awesome-icon(icon="fa-solid fa-plus"  transform="shrink-7")
                                        font-awesome-icon(icon="fa-regular fa-circle")
                        .col-1.minusButton(@click="deleteJob(index)" v-if="index > 0")
                            .row.align-items-end.justify-content-end
                                .col-2
                                    font-awesome-layers.fa-lg.setMinus
                                        font-awesome-icon(icon="fa-solid fa-minus"  transform="shrink-7")
                                        font-awesome-icon(icon="fa-regular fa-circle")
        .form-group.row.gy-2.gx-3-align-items-left
            .hint(v-if="hinted && hinted.length > 0" v-html="hinted") 
            .vueFormSmall.labelred(v-if="schema.errorShow === true")
                font-awesome-icon(icon="fa-solid fa-exclamation" class="errorExclamationMarkColor") 
                | &nbsp;{{ schema.errorText[0] }}
</template>